import styled from "styled-components";
import { Select } from "antd";

export const StyledSelect: typeof Select = styled(Select)`
  width: 300px;
`;
